import Vue from 'vue';
import numberFormatter from './../services/NumberFormatter'

Vue.filter('localized_numeric', function (value) {
  return numberFormatter.localize(numberFormatter.round(value))
});
